<template>
  <div style="display: flex;flex-direction: column">
    <el-select
      v-if="splitBubbleCollectionFormat"
      :value="value||''"
      :disabled="disabled"
      clearable
      @input="onInput"
      @change="onChange"
    >
      <el-option v-for="(item, index) in SPLIT_BUBBLE_COLLECT_ITEMS" :key="index" :label="$getLangColumn(item)" :value="item.code" />
    </el-select>
    <template v-else>
      <el-input-number :value="value" controls-position="right" :min="0" :max="999999999" @input="onInput" @change="onChange" /><span>%</span>
    </template>
  </div>
</template>

<script>
import { SPLIT_BUBBLE_COLLECT_ITEMS } from '@/class/cargo/model/parameters/AirExportConstants'

export default {
  name: 'AeBasicPbProportion',
  props: {
    value: { type: [String, Number], default: 0 },
    disabled: { type: Boolean, default: false },
    splitBubbleCollectionFormat: { type: Boolean, default: false }
  },
  data() {
    return {
      SPLIT_BUBBLE_COLLECT_ITEMS
    }
  },
  methods: {
    onInput(val) {
      this.$emit('input', val)
    },
    onChange(val) {
      this.$emit('change', val)
    }
  }
}
</script>
